import getButtonText from '../../modules/getButtonText';
import { Site } from '../../modules/sites/Site';
import type { Deal } from '../../types/Deal';
import type { Translate } from '../../types/Localiser';

export default (
  deal: Deal,
  translate: Translate,
  merchantlinkTextType: string,
  isPriceEnabled = false,
  site?: Site,
): string => {
  if (merchantlinkTextType) {
    const merchantName = deal.merchant.name ?? '';
    return translate(merchantlinkTextType, [merchantName]);
  }
  if (!deal.offer.price && site?.id === 'decanter') {
    return translate('shopNow');
  }
  return getButtonText(deal, true, translate, isPriceEnabled);
};
